<div class="content-container">
    <div class="picture-container">

        <img src="../../assets/seatwithstraightbackrestformeasurement.svg" class="img-size" />
    </div>
    <div class="flex-container">
        <mat-form-field class="form-field">
            <mat-label>Seat capacity</mat-label>
            <mat-select class="text-right" [disabled]="seat?.seatAmountEditable === false" [value]="seat?.seatAmount"
                (selectionChange)="changeSeatCapacity($event.value)">
                <mat-option class="select-without-checkbox" *ngFor="let capacity of seatCapacities" [value]="capacity">
                    {{capacity}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>h<sub>2</sub></mat-label>
            <input matInput type="number" [ngModel]="adjustableSeat?.heightLowerEdge"
                (ngModelChange)="adjustableSeat.heightLowerEdge = $event" autocomplete="off"
                (keypress)="integerOnly($event)">
        </mat-form-field>
        <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="adjustableSeat?.groundSupport"
            (ngModelChange)="adjustableSeat.groundSupport = $event" class="margin-right form-field">
            Floor support
        </mat-checkbox>
    </div>
</div>